module.exports = __webpack_public_path__ + "static/tabcorp-logo-89b24a5ea7ce99d3ce2b6fbba2b7f5b2.png";